import { render, staticRenderFns } from "./departmentsummary.vue?vue&type=template&id=48fc8613&scoped=true"
import script from "./departmentsummary.vue?vue&type=script&lang=js"
export * from "./departmentsummary.vue?vue&type=script&lang=js"
import style0 from "./departmentsummary.vue?vue&type=style&index=0&id=48fc8613&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fc8613",
  null
  
)

export default component.exports